import gql from 'graphql-tag';

export default gql`
    mutation DeleteVosUploadImage($input: DeleteVosUploadRequest) {
        deleteVosUploadImage(input: $input) {
            errors
        }
    }
`;
